import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { WidgetCard } from '../WidgetCard';
import { Popup } from 'semantic-ui-react';
import { widgetHeight, widgetWidth } from '..';
import { BottomButtonRow, Message } from '../Styles';
import ButtonWithConfirmation from '../ButtonWithConfirmation';
import useStores from '../../../../hooks/use-store';
import { engineToolType } from '../../../../stores/reducers/engineTools';

export const EngineReloadScreensWidget = observer(() => {
  const {
    EngineToolStore: { enginePost: post, widgetReloading },
  } = useStores();

  const [message, setMessage] = useState(null);
  const [success, setSuccess] = useState(null);
  const [app, setApp] = useState(null);
  const [toolTypeLoading, setToolTypeLoading] = useState(null);

  const statusMessageHandler = ({ success, message }) => {
    setMessage(message);
    setSuccess(success);
  };

  const handleConfirmation = (e, app, toolType, args) => {
    e.preventDefault();
    setApp(app);
    setToolTypeLoading(toolType);
    post(toolType, args).then(statusMessageHandler);
  };

  const isLoadingAllBidders =
    widgetReloading[engineToolType.sendSystemMessageForceAllBiddersReload];
  const isLoadingAllClerks =
    widgetReloading[engineToolType.sendSystemMessageForceAllClerksReload];

  return (
    <WidgetCard
      heading="Reload Apps"
      description="Instructs the clerk or bidder screens to automatically perform a hard reload in their browser window"
      width="450px"
      height="235px"
    >
      <BottomButtonRow buttonWidth="150px">
        {message ? (
          <Popup
            data-testid="engine-bidder-reload-popup"
            key="engine-bidder-reload"
            content={message}
            header="Details"
            size="small"
            trigger={
              <Message success={success}>
                {success
                  ? `😃 You have instructed all ${app} screens to automatically perform a hard reload!`
                  : `🤔 Oops, an error occurred while trying to initiate a ${app} screen reload.`}
              </Message>
            }
          />
        ) : (
          <Message />
        )}
      </BottomButtonRow>
      <div>
        <ButtonWithConfirmation
          buttonText="All Bidders"
          buttonIcon="sync"
          onConfirmation={(e) =>
            handleConfirmation(
              e,
              'bidder',
              engineToolType.sendSystemMessageForceAllBiddersReload,
              {
                sessionToken: '57d85f701683411a93d9b3c824f6ff8a',
                actionArguments: 'Bidders|(FORCE_RELOAD)|UserError',
              },
            )
          }
          loading={isLoadingAllBidders}
        />
        <ButtonWithConfirmation
          buttonText="All Clerks"
          buttonIcon="sync"
          onConfirmation={(e) =>
            handleConfirmation(
              e,
              'clerk',
              engineToolType.sendSystemMessageForceAllClerksReload,
              {
                sessionToken: '57d85f701683411a93d9b3c824f6ff8a',
                actionArguments: 'Clerks|(FORCE_RELOAD)|UserError',
              },
            )
          }
          loading={isLoadingAllClerks}
        />
      </div>
    </WidgetCard>
  );
});

export default EngineReloadScreensWidget;
